// parses qr codes in the format "https://trunk.treehacks.com/p/<mongodb-user-object-id>" and returns the user id
const QR_URL_PATTERN =
  /^https?:\/\/trunk\.treehacks\.com\/p\/([a-fA-F0-9]{24})$/;

export const parseQRCode = (qrCode) => {
  if (!qrCode || typeof qrCode !== "string") {
    return null;
  }

  const trimmedCode = qrCode.trim();

  const match = trimmedCode.match(QR_URL_PATTERN);

  if (match && match[1]) {
    return match[1];
  }

  // check if it's a valid mongodb id in case of raw id
  if (/^[a-fA-F0-9]{24}$/.test(trimmedCode)) {
    return trimmedCode;
  }

  return null;
};

// validate
export const isValidObjectId = (id) => {
  if (!id || typeof id !== "string") {
    return false;
  }
  return /^[a-fA-F0-9]{24}$/.test(id);
};

// extract
export const extractUserIdFromUrl = (url) => {
  if (!url || typeof url !== "string") {
    return null;
  }

  try {
    const urlObj = new URL(url.trim());

    if (urlObj.hostname !== "trunk.treehacks.com") {
      return null;
    }

    const pathSegments = urlObj.pathname.split("/").filter(Boolean);

    if (pathSegments.length === 2 && pathSegments[0] === "p") {
      const userId = pathSegments[1];

      if (isValidObjectId(userId)) {
        return userId;
      }
    }

    return null;
  } catch (error) {
    return null;
  }
};

export default parseQRCode;
